<template>
  <div v-bind:class="{'mt-2': !payee}">
    <!-- Row 1: checkbox + name on left, type toggles on right -->
    <div class="level is-mobile mb-3">
      <div class="level-left">
        <div @click="toggleIsPayee()" v-if="payee" class="level-item is-clickable mr-1">
          <i v-if="payee.isPayee" class="far fa-check-square"></i>
          <i v-if="!payee.isPayee" class="far fa-square"></i>
        </div>
        <div
        v-if="payee && payee.name"
        @click="toggleIsPayee()"
        class="level-item payee-name-modifier is-clickable is-unselectable"
        >
          {{ payeeDisplayName }}
        </div>
        <div v-if="!payee" class="level-item mr-1">
          <input
          class="input name-input-modifier has-background-info-light"
          v-bind:class="{'is-danger': newName && newName.length > 0 && isDuplicateNewName}"
          type="text"
          placeholder="Add new name"
          v-model="newName"
          @input="$event.target.composing = false"
          >
        </div>
        <div v-if="!payee" class="level-item">
          <div
          v-if="newName"
          @click="addNewPayee()"
          class="button is-info"
          :disabled="!(newName && newName.length > 0) || isDuplicateNewName"
          v-bind:class="{'glow': newName && newName.length > 0}"
          >
          <i class="fas fa-plus"></i>
          </div>
        </div>
      </div>
      <div v-if="payee && payees.filter(p => p.isPayee).length > 1" class="level-right">
        <div class="tags has-addons level-item">
          <span @click="setPayeeType('equal')" class="tag is-clickable is-large px-2 mb-0" v-bind:class="{'is-info': payee.type === 'equal'}">
            <i class="fas fa-equals"></i>
          </span>
          <span @click="setPayeeType('absolute')" class="tag is-clickable is-large px-2 mb-0" v-bind:class="{'is-info': payee.type === 'absolute'}">
            <i class="fas fa-dollar-sign"></i>
          </span>
          <span @click="setPayeeType('percentage')" class="tag is-clickable is-large px-2 mb-0" v-bind:class="{'is-info': payee.type === 'percentage'}">
            <i class="fas fa-percentage"></i>
          </span>
        </div>
      </div>
    </div>
    <!-- Row 2: full-width amount input, shown when type requires a value -->
    <div
      v-if="payee && ['absolute', 'percentage'].includes(payee.type) && payees.filter(p => p.isPayee).length > 1"
      class="field has-addons mb-2"
    >
      <div class="control">
        <span class="button is-static">
          <i v-if="payee.type === 'absolute'" class="fas fa-dollar-sign"></i>
          <i v-else class="fas fa-percentage"></i>
        </span>
      </div>
      <div class="control is-expanded">
        <input
        class="input"
        v-bind:class="{'glow': payee.isPayee && (!localValue || localValue < 0)}"
        type="number"
        placeholder="0"
        v-model="localValue"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Payee',
  props: ['payees', 'payee'],
  data() {
    return {
      amountInput: null,
      newName: null
    }
  },
  computed: {
    isDuplicateNewName(){
      return this.$store.state.event.names.includes(this.newName)
    },
    localValue: {
      get () {
        return this.payee && this.payee.amount ? this.payee.amount : null
      },
      set (value) {
        if(value !== this.localValue){
          this.$emit('updatePayeeAmount', Number(value))
        }
      }
    },
    payeeDisplayName() {
      return this.payee.name.length < 12 ? this.payee.name : this.payee.name.substring(0, 12) + '...'
    }
  },
  watch: {
    localValue(newLocalValue) {
      if(newLocalValue > 0 && !this.payee.isPayee) {
        this.$emit('updatePayeeIsPayee', true)
      }
    },
    newName(newName) {
      if(newName) {
        this.$emit('updateIsAdding', true)
      } else {
        this.$emit('updateIsAdding', false)
      }
    }
  },
  methods: {
    toggleIsPayee() {
      if(this.payee.isPayee){
        this.localValue = null
      }
      this.$emit('updatePayeeIsPayee', !this.payee.isPayee)
    },
    setPayeeType(payeeType) {
      this.$emit('updatePayeeIsPayee', true)
      this.$emit('setPayeeType', payeeType)
    },
    addNewPayee() {
      if(
        this.newName &&
        this.newName.length > 0 &&
        !this.isDuplicateNewName
      ){
        this.$emit('addNewPayee', { newName: this.newName })
        this.newName = null
      }
    }
  }
}
</script>

<style>
.payee-name-modifier {
  flex: 1;
}

.name-input-modifier {
  min-width: 160px !important;
}
</style>
